import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { HashLink } from 'react-router-hash-link';
import {
  AppBar,
  Button,
  Toolbar,
  withStyles,
  withMobileDialog,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import propTypes from '../../../utils/propTypes';
import {
  loginRequest,
  signupRequest,
} from '../../../redux/auth/actions';
import { hideHeader } from '../../../utils/menu';
import PingumLogo from '../../widgets/PingumLogo';
import UserMenu from '../UserMenu';
import styles from './styles';

export class NavBarComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { headerVisible: hideHeader(window.pageYOffset) };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  getAppBarClassName = () => {
    if (this.props.forceVisible) {
      return '';
    }
    return !this.state.headerVisible
      ? 'transparent'
      : '';
  }

  handleScroll = () => {
    this.setState((prev) => ({
      ...prev,
      headerVisible: hideHeader(window.pageYOffset),
    }));
  }

  render() {
    const {
      classes,
      fullScreen,
      showHomeLinks,
    } = this.props;
    return (
      <div>
        <AppBar position="fixed" color="primary" className={this.getAppBarClassName()}>
          <Toolbar className={classes.toolbar}>
            <h6
              id="title"
              variant="h6"
              className={classes.title}
            >
              <Link
                to="/"
                href="/"
                className={classes.link}
                role="button"
              >
                <PingumLogo removePadding />
              </Link>
            </h6>
            {
              (!fullScreen && showHomeLinks)
                && (
                  <div style={{ marginRight: 50 }}>
                    <Link
                      to="/contact-us"
                      href="/contact-us"
                      tabIndex={-1}
                    >
                      <Button
                        style={{ color: 'white' }}
                        name="contact-us"
                      >
                        Contact Us
                      </Button>
                    </Link>
                    <HashLink
                      to="/#pricing"
                      href="/#pricing"
                      onClick={this.handleClose}
                      tabIndex={-1}
                    >
                      <Button
                        style={{ color: 'white' }}
                        name="pricing"
                      >
                        Pricing
                      </Button>
                    </HashLink>
                    <HashLink
                      to="/#video-demo"
                      href="/#video-demo"
                      onClick={this.handleClose}
                      tabIndex={-1}
                    >
                      <Button
                        style={{ color: 'white' }}
                        name="watch-demo"
                      >
                        Demo
                      </Button>
                    </HashLink>
                  </div>
                )
              }
            {
              !!this.props.auth.isAuthenticated
                && !!this.props.user
                && !this.props.showLogin
                && <UserMenu />
            }
            {
              (!this.props.auth.isAuthenticated || !!this.props.showLogin)
                && !fullScreen
                && (
                  <div>
                    <Button
                      color="inherit"
                      onClick={this.props.login}
                      name="login"
                    >
                      Login
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={this.props.signup}
                      name="signup"
                    >
                      Signup
                    </Button>
                  </div>
                )
            }
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

NavBarComponent.propTypes = {
  auth: PropTypes.shape({
    isAuthenticated: PropTypes.bool.isRequired,
    error: PropTypes.object,
    isFetching: PropTypes.bool,
  }).isRequired,
  classes: PropTypes.object.isRequired,
  user: PropTypes.shape(propTypes.user),
  login: PropTypes.func,
  signup: PropTypes.func,
  forceVisible: PropTypes.bool,
  showLogin: PropTypes.bool,
  fullScreen: PropTypes.bool,
  showHomeLinks: PropTypes.bool,
};

NavBarComponent.defaultProps = {
  user: null,
  login: () => {},
  signup: () => {},
  forceVisible: false,
  showLogin: false,
  fullScreen: false,
  showHomeLinks: false,
};

export const mapStateToProps = (state) => ({
  auth: state.auth,
  user: state.user.user,
});

export const mapDispatchToProps = (dispatch) => ({
  login: () => dispatch(loginRequest()),
  signup: () => dispatch(signupRequest()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withMobileDialog({ breakpoint: 'sm' })(NavBarComponent)));
